import { m, type MithrilVNode } from '../../mithril';
import type { MaterialIcon } from './icons';

const CONST_CLASS_OBJ = { className: 'material-icons' };

export function view(icon: MaterialIcon | MithrilVNode, opts?: { className?: string; [key: string]: any }) {
	if (opts == null) {
		return m('i', CONST_CLASS_OBJ, icon);
	}

	if (opts.className) {
		opts.className = opts.className + ' material-icons';
	} else {
		opts.className = 'material-icons';
	}

	return m('i', opts, icon);
}

export const Icon = { view };
